import React from "react";
import Footer from "../Component/Footer/Footer";
import Header from "../Component/Header/Header";
import Createnft from "Pages/Createnft/Createnft";
import Latestupdate from "../Component/Latestupdate/Latestupdate";
import Createnftphysical from "Pages/CreatenftPhisical/Createnftphysical";
export default function Createnftthemephysical() {
  return (
    <>
      {/* <Header /> */}
      <Createnftphysical />
      {/* <Latestupdate />
      <Footer /> */}
    </>
  );
}
